export default function BottomCta() {
  return (
    <section className="w-full bg-[#064e3b] py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-[720px] mx-auto text-center">
        <h2 className="font-roboto font-bold text-2xl md:text-[36px] text-white mb-3">
          Broken Glass? We Can Help
        </h2>
        <p className="text-[#fefce8] text-base mb-8">
          Call for a free phone quote. We confirm scope fit before any visit.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center justify-center gap-2 bg-[#ea580c] text-white px-8 py-3.5 text-sm font-bold rounded-lg hover:bg-[#c2410c] transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            Call (786) 377-4452
          </a>
          <a
            href="mailto:contact@impact-window-repair-miami.com"
            className="inline-flex items-center justify-center text-white border-2 border-white px-8 py-3.5 text-sm font-bold rounded-lg hover:bg-white hover:text-[#064e3b] transition-colors whitespace-nowrap"
          >
            Email Windows and Doors Repair Miami
          </a>
        </div>
      </div>
    </section>
  );
}